<!-- モーダルヘッダーが入ります -->
<div class="p-modal-head02">
  <h1 id="modalTitle" class="p-modal-head02__title p-modal-head02__title--blue">
    <span class="c-text-with-tooltip__text" [innerHTML]="'label.advancedLounge' | staticMsg" role="button"></span>

    <!-- ヘルプアイコン -->
    <asw-tooltip
      iconImage="<img src=&quot;assets/images/icon_help_primary_24.svg&quot; alt=&quot;{{
        'alt.helpIcon2' | staticMsg
      }}&quot; width=20 height=20>"
      [tooltipContent]="tooltipContent"
      tooltipDisplayType="tap"
      [tooltipTop]="-80"
      [displayAreaClass]="'p-modal-head02'"
    ></asw-tooltip>
  </h1>

  <button class="p-modal-head01__close js-modal-close" id="btn-cancel-event-id" (click)="onClickCancel()">
    <span class="u-visually-hidden" [innerHTML]="'alt.closeModal' | staticMsg"></span>
  </button>
</div>
<!-- //モーダルヘッダーが入ります -->
